<!--
  * name: BrandFilm
  * description: [Main] BrandFilm 컴포넌트 페이지
-->
<template>
  <div>
    <bread-crumb location="Brand Film"></bread-crumb>
    <!-- 병헌 : 경로 -->
    <title-area />
    <film :filmInfo="filmInfo.LIFENING"/>
  </div>
</template>

<script>
import BreadCrumb from '@/components/breadcrumb/BreadCrumb.vue';
import snsApi from '@/apis/sns';
import TitleArea from './partial/TitleArea.vue';
import Film from './partial/Film.vue';

export default {
  name: 'BrandFilm',
  components: {
    BreadCrumb,
    TitleArea,
    Film,
    snsApi,
  },
  created() {
    this.init();
  },
  data() {
    return {
      filmInfo: {},
    };
  },
  methods: {
    async init() {
      const result = await snsApi.getBrandFilms();
      if (result.error) {
        alert('오류가 발생했습니다.');
        return;
      }
      this.filmInfo = result;
    },
  },
};
</script>

<style lang='scss' scoped>
@media (max-width: $mobile-size) {
  /deep/ .tit-wrap{
    .tit-style{
      h1{
          text-align: left;
      }
    }
    .txt-tit-desc {
      margin-bottom: 5rem;
      text-align: left;
      @media (max-width: $mobile-size) {
        margin-bottom: 2rem;
      }
    }
    .text-center{
      text-align: left !important;
    }
  }
}
/deep/ .youtube-a{
  display: inline-block;
  width: 5.4rem;
  &--img{
    width: 100%;
  }
}
/deep/ .swiper-container {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  .swiper-slide {
    background-size: cover;
    background-position: center;
    .swiper-b-img{
      width: 100%;
    }
    .swiper-s-img{
      width: 100%;
    }
    .swiper-txt{
      font-size: 1.6rem;
      color: #333333;
      @include cut-txt(2, 1.5);
      @media (max-width: $mobile-size) {
        font-size: inherit;
      }
    }
  }
}

/deep/ .t-top {
  width: 100%;
}
/deep/ .t-thum {
  height: 20%;
  box-sizing: border-box;
  padding: 10px 0;
  .swiper-wrapper{
    display: flex;
    justify-content: space-between;
  }
}
/deep/ .t-thum .swiper-slide {
  width: 19%;
  opacity: .6;
}
/deep/ .t-thum .active {
  opacity: 1;
}
.mt-16{
  margin-top: 16rem !important;
  @media (max-width: $mobile-size) {
    margin-top: 4rem !important;
  }
}
</style>
